import addError from '../../../utils/error.jsx';

export function request() {
    return {
        type: 'GET_LIABILITY_ALERTS'
    };
}

export function error(errors) {
    addError(errors);

    return {
        type: 'ERROR_LIABILITY_ALERTS',
        errors
    };
}

export function finish(selections) {
    return {
        type: 'FINISH_LIABILITY_ALERTS',
        selections
    };
}
